import React from "react";
import { useDimensions } from "../Util";

const Footer=()=>{

    const {w,h} = useDimensions();

    const footer = {
        width:100*w,
        height:4*h,
        backgroundColor:"#00ADB5",
        display:"flex",
        justifyContent:"center",
        alignItems:"center"
    }

    const smallFontSize = {
        fontSize:w>h?"clamp(10px,12px,15px)":"clamp(7px,10px,12px)",
        fontWeight:"300",
        color:"#222831"
    }

    return <div id="footer" style={footer}>
        <p style={smallFontSize}>For demonstration purposes only | feedback@aec.social | V0.1</p>
    </div>  
}

export default Footer;